class JsonUtils {
    static toJson(value) {
        try {
            return JSON.stringify(value);
        }
        catch (error) {
            console.error(error);
        }
    }
    static fromJson(value) {
        try {
            return JSON.parse(value);
        }
        catch (error) {
            console.error(error);
        }
    }
}

export { JsonUtils };
//# sourceMappingURL=json_utils.js.map
